import { cx } from '@linaria/core';
import { DragEvent, Ref } from 'react';
import DragIndicator from '../Icons/DragIndicator';
import "./DragHandle.linaria.module.css!=!./DragHandle?./DragHandle.linaria.module.css?css=H4sIAAAAAAAAA11Ry07DMBC88xW9IMHBVQ0tTcPHWOvYsZ263mCv88Di3xGPpNDjzszOama3QBeRG8El7Hs7F4oQkiOHocYeGkfzZrfdp42GpJkLDDO9ftxtv7aelOBctmr3fjMWCc3ZRMxBsQY9xnqA+MAYDEAQmQRlNLM46Pi4eLWN4PYFu/x+M5YuJ3LtzBoMpAPVjQ6k47J36YTx89heSo/ui2B60IFSHTDoRWT/ea9TAe9MYI70Jd3ankWiMFZV6fG3DZAJfabV9NAJnpJ0yhaJUenIIiiXU33Y3S+aUyeOz6DGrjQ5Joy10i1kvzZ4SoLTNLrBF+VS72GuW6+nhT7vhVN9a/bl9xX1bu3rbaG8bumK03nBCfsrfIrWjoJPx2OlcZMGU37+Mlp3TTS9hOiPIlTTYMO3aD27Pf0pnI/ZpHC4bRwy4Z/g/M10lcxLchNBvn7cfQJKotm5bwIAAA=="
const stylesRoot = "atm_uc_1ba4phy atm_2d_11bfd0z atm_fc_1h6ojuz atm_mj_glywfm atm_h_1h6ojuz atm_mk_stnw88 atm_5j_1ssbidh atm_9j_73adwj atm_9s_1txwivl atm_k4_idpfg4 atm_fq_idpfg4 atm_tk_idpfg4 atm_9rhhw_1x778eo atm_x6nrl7_n8xvhn";
const stylesEnableDrag = "atm_mj_1wugsn5 atm_9j_1qgj8bu";
type DragHandleProps = {
  ref?: Ref<HTMLSpanElement>;
  size: number | string;
  enableDrag: boolean;
  className: string;
  onDragStart: (event: DragEvent<HTMLSpanElement>) => void;
  onDragEnd: (event: DragEvent<HTMLSpanElement>) => void;
  onDrag: (event: DragEvent<HTMLSpanElement>) => void;
};
const DragHandle = (props: DragHandleProps) => {
  const {
    onDragStart,
    onDragEnd,
    onDrag,
    enableDrag,
    className,
    size,
    ref
  } = props;
  return <span draggable={enableDrag} ref={ref} onDragStart={onDragStart} onDragEnd={onDragEnd} onDrag={onDrag} style={{
    height: size,
    width: size
  }} className={cx(stylesRoot, enableDrag && stylesEnableDrag, className)}>
            <DragIndicator data-testid="DragIndicatorIcon" />
        </span>;
};
export default DragHandle;